import { Link } from "react-router-dom";

import blog from "assets/images/footer/blog.svg";
import facebook from "assets/images/footer/facebook.svg";
import instagram from "assets/images/footer/instagram.svg";

const Sns = () => {
  return (
    <div className="flex gap-2 md:gap-[6px]">
      <Link to="https://www.instagram.com/macodi_official" target="_blank">
        <img src={instagram} alt="" width={30} className="md:w-[22px]" />
      </Link>
      <Link to="https://www.facebook.com/material.codi" target="_blank">
        <img src={facebook} alt="" width={30} className="md:w-[22px]" />
      </Link>
      <Link to="https://blog.naver.com/macodi_official" target="_blank">
        <img src={blog} alt="" width={30} className="md:w-[22px]" />
      </Link>
    </div>
  );
};

export default Sns;
